/**
 * "THE GOOD GUYS - PENRITH" → "The Good Guys - Penrith". A word starts after a space, "-", "/",
 * "(" or "&"; acronyms aren't preserved ("AV/IT" → "Av/It").
 */
export const toTitleCase = (value: string): string => {
  return value
    .trim()
    .toLowerCase()
    .replace(/(^|[\s\-/(&])(\p{L})/gu, (_match, boundary: string, letter: string) => boundary + letter.toUpperCase());
};
